export function round(value, decimals = 2) {
  if (value == null || Number.isNaN(value)) return null;
  // pre round to avoid floating point issues
  const newValue = Math.round(value * 10 ** 5) / 10 ** 5;
  return Math.round(newValue * 10 ** decimals) / 10 ** decimals;
}
